import request from '@/utils/http'

const PREFIX = '/eventAttribute'

const eventAttribute = {
  listByEventId(proId, evnId) {
    return request(
      `${PREFIX}/${proId}/${evnId}`,
      'get'
    )
  },

  deleted(id) {
    return request(
      `${PREFIX}/` + id,
      'delete'
    )
  },

  update(id, data) {
    return request(
      `${PREFIX}/` + id,
      'put',
      data
    )
  },

  listEventAttr(param) {
    return request(
      `${PREFIX}/list/attr`,
      'get',
      param
    )
  },

  listEventAttrs(param) {
    return request(
      `${PREFIX}/list/attrs?param=${encodeURIComponent(JSON.stringify(param))}`,
      'get'
    )
  }

}

export default eventAttribute
